import { call, put, takeLatest } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { IThoiKhoaBieuViewLoadStart, eIThoiKhoaBieuViewActionTypeIds } from "../../action-types/thoi-khoa-bieu/IThoiKhoaBieuViewActionType";
import { thoiKhoaBieuViewAction } from "../../actions/thoi_khoa-bieu/thoiKhoaBieuViewAction";

const thoiKhoaBieuChiTietApi = apiWrapper.thoiKhoaBieuChiTietApi;

export function* thoiKhoaBieuViewSaga(): any {
    yield takeLatest(eIThoiKhoaBieuViewActionTypeIds.LOAD_START, loadWorker)

}
function* loadWorker(action: IThoiKhoaBieuViewLoadStart): any {

    const res: IBaseResponeModel = yield call([thoiKhoaBieuChiTietApi, thoiKhoaBieuChiTietApi.Select], action.payload)
    if (res.is_success) {
        yield put(thoiKhoaBieuViewAction.loadSuccess(res.data))
    } else {
        yield put(thoiKhoaBieuViewAction.loadError(res.message || "Không tải được thời khóa biểu"))
    }
}